<template>
  <TextInput
    :id="$attrs.id || 'district'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'district'"
    :label="$attrs.label || 'Bairro'"
    :placeholder="$attrs.placeholder || 'Nome do bairro'"
    :validations="
      $attrs.validations || 'required|rgx:persona.residence.district'
    "
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'DistrictInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
